// extracted by mini-css-extract-plugin
export default {"summary":"SummaryOfSale__summary-wnds","completedSummary":"SummaryOfSale__completedSummary-Dg9I"};